.CardContainerList {
  display: flex;
  /* height: 100%; */
  padding: 24px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 30px;
  background: var(--colori-neutri-background);
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.MonumentsBlock {
  /* width: calc(100% - 225px); */
  height: 100%;
  width: 100%;
  /* transition: all 0.5s ease-in-out; */
}

.MonumentsBlockWithDetail {
  /* width: calc(100%); */
  height: 100%;
  width: 100%;
  /* transition: all 0.5s ease-in-out; */
}

.InputSearch {
  height: 45px;
  padding: 8px 48px;
  align-items: center;
  gap: 16px;
  border-radius: 30px;
  border: 1px solid var(--secondary-variant, #eff8fb);
  background: var(--colori-neutri-white, #fff);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  width: 100%;
  color: var(--secondary);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.InputSearch:focus-visible {
  border-radius: 30px;
  border: 1px solid var(--secondary-variant, #eff8fb);
  background: var(--colori-neutri-white, #fff);
  box-shadow: 1px 2px 0px 0px rgba(17, 138, 178, 0.23);
  outline: none;
}

.SearchIcon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
}

.ClearSearch {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.ListContainer {
  width: 100%;
  height: 100%;
  border-radius: 30px;
  margin-left: 8px;
  position: relative;
  overflow: hidden;
}

.ListMonuments {
  border-radius: 10px;
  background: var(--overlay);
  margin-top: 8px;
  padding: 8px;
  height: calc(100% - 52px);
  overflow-y: auto;
  position: relative;
  width: 100%;
}

.MonumentCard {
  display: flex;
  min-height: 84px;
  padding: 16px 24px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  margin-bottom: 4px;
  cursor: pointer;
  position: relative;
}

.MonumentCardWithDetail {
  display: flex;
  min-height: 84px;
  padding: 16px 24px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  margin-bottom: 4px;
  cursor: pointer;
  background: var(--colori-neutri-gray-2);
  position: relative;
}

.MonumentTitle {
  color: var(--primary);
  overflow: hidden;
  text-overflow: ellipsis;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  max-width: max-content;
}

.City {
  color: var(--colori-neutri-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.NumberPhoto {
  color: var(--primary);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
}

.Distance {
  color: var(--colori-neutri-gray);
  text-align: center;
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 4px;
}

.CardDetail {
  display: flex;
  position: relative;
  width: 650px;
  height: 100%;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 30px;
  background: var(--colori-neutri-background);
  margin-left: 8px;
}

.LegendButton {
  position: absolute;
  right: 16px;
  bottom: 16px;
  border-radius: 30px;
  background: var(--primary);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  transition: all 0.3s ease-in-out;
}

.LegendButton:hover {
  background: rgba(17, 138, 178, 0.8);
  cursor: pointer;
}

.LegendButtonActive {
  border-radius: 30px;
  border: 3px solid var(--secondary);
  background: var(--primary);
  box-shadow: 0px 0px 10px 0px #bdecff;
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
}

.NessunRisultato {
  color: var(--primary);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.SwitchMapList {
  height: 45px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 30px;
  background: var(--primary);
  width: 245px;
  margin-left: 8px;
  margin-right: 8px;
}

.SwitchItemActive {
  border-radius: 100px;
  background: var(--colori-neutri-white);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  color: var(--primary);
  padding: 8px 4px;
  cursor: pointer;
  width: 50%;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.SwitchItem {
  color: var(--colori-neutri-gray-2);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-family: var(--font-roboto-slab);
  padding: 8px 4px;
  cursor: pointer;
  width: 50%;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-right: 4px;
}

.SwitchItem:hover {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
}

.DisabledEntry {
  border: 1px solid var(--tertiary);
  background: #ffe6e3 !important;
}

.DisabledEntryLabel {
  position: absolute;
  right: 0px;
  top: 0px;
  border-radius: 5px;
  background: var(--tertiary);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: var(--colori-neutri-white);
  padding: 2px 4px;
  font-family: var(--font-roboto-slab);
}




.ButtonLegend {
  display: flex;
  width: 60px !important;
  height: 44px !important;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  cursor: pointer;
}

.ButtonLegend:hover,
.ButtonLegend:active {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}

.FiltersColumn {
  height: 100%;
  flex: 0 0 auto;
  overflow: hidden;
}

.ResizeHandle {
  width: 8px;
  min-width: 8px;
  height: 100%;
  cursor: col-resize;
  position: relative;
  flex: 0 0 auto;
}

.ResizeHandle::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  /* background: rgba(0, 0, 0, 0.08); */
  transition: background 0.2s ease;
}

